<template>
  <div>
    <h1>Usuários</h1>

    <b-row>
      <b-col>
        <router-link :to="'./create'">
          <b-button size="sm">{{ $t("geral.create") }}</b-button>
        </router-link>

        <router-link
          :to="'./importUser'"
          v-if="$store.getters.importUser == true"
          class="ml-2"
        >
          <b-button size="sm">{{ $t("userProfile.importUser") }}</b-button>
        </router-link>
      </b-col>
    </b-row>

    <div>
      <b-row>
        <b-table
          hover
          class="table-nowrap"
          :busy.sync="tableIsBusy"
          :items="myProvider"
          :fields="fields"
          :filter="tableFilters"
          :filter-debounce="500"
          :per-page="tablePerPage"
          :sort-by="sortBy"
          :sort-desc="sortDesc"
          :current-page="tableCurrentPage"
        >
          <template slot="thead-top" slot-scope="{ fields }">
            <b-tr>
              <b-th v-for="field in fields" :key="field.key">
                <div v-if="field.key == 'active'">
                  <b-form-select
                    class="statusStyle"
                    :options="optionsActive"
                    v-model="tableFilters[field.key]"
                  >
                  </b-form-select>
                </div>
                <div v-else>
                  <div v-if="tableFilters[field.key] != null">
                    <b-form-input
                      v-model="tableFilters[field.key]"
                      :placeholder="'Buscar por ' + field.label"
                    />
                  </div>
                </div>
              </b-th>
            </b-tr>
          </template>

          <template v-slot:cell(id)="data">
            <router-link :to="'./edit/' + data.value">
              <b-button size="sm">{{ $t("geral.editar") }}</b-button>
            </router-link>
            <b-button
              v-if="isUserActive(data.item)"
              size="sm"
              class="btn-checklist ml-2"
              @click="userDeactivate(data.item)"
              >{{ $t("geral.disable") }}
            </b-button>
            <b-button
              v-else
              size="sm"
              class="btn-checklist ml-2"
              @click="userActivete(data.item)"
              >{{ $t("geral.activate") }}</b-button
            >
          </template>
        </b-table>
      </b-row>

      <b-row>
        <b-col>
          <table-pagination
            :currentPage.sync="tableCurrentPage"
            :pageOptions.sync="tablePageOptions"
            :rowCount.sync="tableRowCount"
            :perPage.sync="tablePerPage"
          />
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    TablePagination: () =>
      import("@/components_rms/base/TablePaginationProps.vue"),
  },
  name: "List",
  props: {
    module: String,
  },
  data: function () {
    return {
      optionsActive: [
        { value: "0", text: "Todos" },
        { value: "1", text: "Sim" },
        { value: "2", text: "Não" },
      ],
      fields: [
        {
          // ACTIONS ( Não sei o pq )
          key: "id",
          sortable: false,
          label: " ",
        },
        {
          key: "companyFantasyName",
          label: "Empresa",
          sortable: true,
        },
        {
          key: "accessName",
          label: "Nome de acesso",
          sortable: true,
        },
        {
          key: "displayName",
          label: "Nome de apresentação",
          sortable: true,
        },
        {
          key: "email",
          label: "E-mail",
          sortable: true,
        },
        {
          key: "profileName",
          label: "Perfil",
          sortable: true,
        },
        {
          key: "cellphone",
          label: "Celular",
          sortable: true,
        },
        {
          key: "telephone",
          label: "Telefone",
          sortable: true,
        },
        {
          key: "active",
          filterKey: "active",
          label: "Ativo",
          sortable: true,
          tdClass: "actions",
          formatter: (value, key, item) => {
            if (value) {
              return "Sim";
            }
            return "Não";
          },
        },
      ],
      tableFilters: {
        active: "1",
        companyFantasyName: "",
        accessName: "",
        displayName: "",
        email: "",
        profileName: "",
        cellphone: "",
        telephone: "",
      },
      sortBy: "",
      sortDesc: true,
      tableIsBusy: false,
      tableRowCount: 0,
      tablePerPage: 10,
      tablePageOptions: [5, 10, 25, 50, 100, 150],
      tableCurrentPage: 1,
      tableSelectMode: "single",
      tableSelectedItem: [],
    };
  },
  computed: {
    paginationFrom() {
      return this.tablePerPage * (this.tableCurrentPage - 1) + 1;
    },
    paginationTo() {
      let to = this.paginationFrom - 1 + this.tablePerPage;
      if (to > this.tableRowCount) return this.tableRowCount;
      return to;
    },
  },
  methods: {
    isUserActive(user) {
      if (user) {
        return user.active;
      }
      return true;
    },
    myProvider(ctx, callback) {
      this.tableIsBusy = true;
      this.apiFilter = {
        currentPage: ctx.currentPage,
        perPage: (ctx.perPage = ctx.perPage),
        Active: ctx.filter.active,
        AccessName: ctx.filter.accessName,
        Cellphone: ctx.filter.cellphone,
        CompanyFantasyName: ctx.filter.companyFantasyName,
        DisplayName: ctx.filter.displayName,
        Email: ctx.filter.email,
        ProfileName: ctx.filter.profileName,
        Telephone: ctx.filter.telephone,
        sortBy: ctx.sortBy,
        sortDesc: ctx.sortDesc,
      };

      this.$apiScheduler
        .post("/usuario/all/", this.apiFilter)
        .then((response) => {
          console.log(response);
          console.log(response.data.items);
          console.log(response.data.totalItems);
          const items = response.data.items;
          this.tableIsBusy = false;
          this.tableRowCount = response.data.totalItems;
          callback(items);
        })
        .catch((error) => {
          console.log(error);
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.tableIsBusy = false;
            this.tableRowCount = 0;
            callback([]);
          }
        });
      return null;
    },
    userActivete(user) {
      this.$apiScheduler
        .get("/user/activate/" + user.id.toString())
        .then((response) => {
          // console.log("entrou")
          user.active = true;
          this.alert.success = response.data.title;
          this.$refs.alert.show();
        })
        .catch((error) => {
          console.log(error.response);
          this.alert.error =
            error.response.status + " - " + error.response.statusText;
          this.$refs.danger.show();
        });
    },
    userDeactivate(user) {
      this.$apiScheduler
        .get("/user/deactivate/" + user.id.toString())
        .then((response) => {
          // console.log("entrou")
          user.active = false;
          this.alert.success = response.data.title;
          this.$refs.alert.show();
        })
        .catch((error) => {
          console.log(`error: ${error}`);
          console.log(error);
          console.log(`error.response: ${error.response}`);
          console.log(error.response);

          this.alert.error =
            error.response.status + " - " + error.response.statusText;
          this.$refs.danger.show();
        });
    },
  },
};
</script>

